import AvatarImage from 'ui/Element/Image/Avatar'
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getFirstItem } from 'lib/util'
import { getDocumentationIcon } from 'lib/util/icon'

const styles = theme => ({
  root: {
    width: '3rem',
    height: '3rem',
  },
  image: {
    maxWidth: '40px',
    width: '100%',
    height: '100%',
  },
})

/**
 * Displays the icon of the equipment ot part
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellFavoriteIcon = (classes, props = {}) => {
  const {
    image,
    type: typeKey,
    docType,
    status,
    documentationType,
    events,
  } = props

  const targetType = docType
    ? docType === 'documentation' && { name: documentationType || typeKey, nodeType: docType }
    : null
  const icon = targetType ? getDocumentationIcon(targetType) : null

  const [type] = events?.getTicketType?.(typeKey) || []
  const typeIcon = type?.icon
  const { color, backgroundColor } = getFirstItem(events?.getRequestStatus?.(status)) || {}

  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image?.id || undefined, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  const fallbackIcon = (docType === 'article' && 'part')
    || (docType === 'equipment' && 'monitor')
    || (docType === 'documentation' && 'document')
    || (docType === 'organisation' && 'building-05')
    || (docType === 'serviceitem' && 'device')
    || (docType === 'person' && 'user')
    || (docType === 'request' && 'request')

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <AvatarImage
        shape={'circular'}
        attachment={attachment}
        icon={{
          source: typeIcon || icon || fallbackIcon,
          color: color || 'text.regular',
          background: backgroundColor || 'gray.960',
          size: 24,
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellFavoriteIcon, styles)
